var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "content" } },
    [
      _c("div", { staticClass: "header col-md-12" }, [
        _c("div", { staticClass: "header-inner row align-items-center" }, [
          _c("div", { staticClass: "col left" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("sidebar.purchaseorder")) +
                  " > " +
                  _vm._s(_vm.$t("sidebar.create")) +
                  "\n        "
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content col-md-12" },
        [
          !_vm.ready
            ? _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))])
            : _vm._e(),
          _vm._v(" "),
          _vm.ready
            ? [
                _c("section", [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding" },
                    [
                      _c("section-header", {
                        attrs: {
                          title: _vm.$t("message.vendor"),
                          subtitle: _vm.$t("series.po") + " " + _vm.nextPoCode
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-md-12" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c(
                              "div",
                              { staticClass: "col" },
                              [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(_vm.$t("message.storecompanyperson"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("selectize", {
                                  attrs: {
                                    default: _vm.form.defaultVendorId,
                                    updateoption: _vm.form.updateOptionVendor,
                                    options: _vm.form.optionVendors,
                                    multiple: false,
                                    create: true,
                                    loading: _vm.form.loadingVendor,
                                    validation: _vm.form.trickValidationVendor,
                                    placeholder: _vm.$t(
                                      "placeholder.selectorcreate"
                                    )
                                  },
                                  on: { add: _vm.onAddedVendor },
                                  model: {
                                    value: _vm.form.pickedVendorId,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "pickedVendorId", $$v)
                                    },
                                    expression: "form.pickedVendorId"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.form.pickedVendorId
                        ? _c("div", { staticClass: "form-row" }, [
                            _c("div", { staticClass: "col-md-6" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "form-group row",
                                  staticStyle: { height: "100%" }
                                },
                                [
                                  _c("div", { staticClass: "col-md-12" }, [
                                    _c("label", [
                                      _vm._v(_vm._s(_vm.$t("message.address")))
                                    ]),
                                    _vm._v(" "),
                                    _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.form.vendor.address,
                                          expression: "form.vendor.address"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      staticStyle: {
                                        height: "calc(100% - 37px)"
                                      },
                                      domProps: {
                                        value: _vm.form.vendor.address
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.form.vendor,
                                            "address",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ])
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-6" }, [
                              _c("div", { staticClass: "form-group row" }, [
                                _c("div", { staticClass: "col-md-12" }, [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.$t("message.tel")))
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.form.vendor.tel,
                                        expression: "form.vendor.tel"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    attrs: { type: "text" },
                                    domProps: { value: _vm.form.vendor.tel },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.form.vendor,
                                          "tel",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-group row" }, [
                                _c("div", { staticClass: "col-md-12" }, [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.$t("message.email")))
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.form.vendor.email,
                                        expression: "form.vendor.email"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    attrs: { type: "text" },
                                    domProps: { value: _vm.form.vendor.email },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.form.vendor,
                                          "email",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-group row" }, [
                                _c("div", { staticClass: "col-md-12" }, [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.$t("message.taxpayerno")))
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.form.vendor.tax_id,
                                        expression: "form.vendor.tax_id"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    attrs: { type: "text" },
                                    domProps: { value: _vm.form.vendor.tax_id },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.form.vendor,
                                          "tax_id",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ])
                              ])
                            ])
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("section", [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding" },
                    [
                      _c("section-header", {
                        attrs: { title: _vm.$t("message.date") }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c(
                              "div",
                              { staticClass: "col" },
                              [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$t("message.date")))
                                ]),
                                _vm._v(" "),
                                _c("BaseInputDatePicker", {
                                  model: {
                                    value: _vm.form.created_at,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "created_at", $$v)
                                    },
                                    expression: "form.created_at"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c(
                              "div",
                              { staticClass: "col" },
                              [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "apps.purchases.message.purchasetype"
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("BaseDropdown", {
                                  attrs: { options: _vm.purchaseOptions },
                                  model: {
                                    value: _vm.form.purchase_type,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "purchase_type", $$v)
                                    },
                                    expression: "form.purchase_type"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col",
                            on: {
                              click: function($event) {
                                _vm.isFocusOnInputScheduled = false
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "form-group row" }, [
                              _c("div", { staticClass: "col" }, [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$t("message.credittype")))
                                ]),
                                _vm._v(" "),
                                _vm.form.selectedCredit !== "custom"
                                  ? _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.form.selectedCredit,
                                            expression: "form.selectedCredit"
                                          }
                                        ],
                                        staticClass:
                                          "form-control custom-select",
                                        on: {
                                          change: function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.$set(
                                              _vm.form,
                                              "selectedCredit",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "option",
                                          { attrs: { value: "cash" } },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("message.cash"))
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          { attrs: { value: "days.15" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("message.creditdasys", {
                                                  number: 15
                                                })
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          { attrs: { value: "days.30" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("message.creditdasys", {
                                                  number: 30
                                                })
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          { attrs: { value: "days.60" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("message.creditdasys", {
                                                  number: 60
                                                })
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          { attrs: { value: "days.90" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("message.creditdasys", {
                                                  number: 90
                                                })
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          { attrs: { value: "custom" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "message.customcreditdays"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _c("div", { staticClass: "input-group" }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.form.inputCustomCreditDay,
                                            expression:
                                              "form.inputCustomCreditDay"
                                          }
                                        ],
                                        ref: "custom_credit_days",
                                        staticClass:
                                          "form-control text-right number-only text-select-all",
                                        staticStyle: { "border-right": "none" },
                                        attrs: { type: "text" },
                                        domProps: {
                                          value: _vm.form.inputCustomCreditDay
                                        },
                                        on: {
                                          keyup: _vm.keyupInputCustomCreditDay,
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.form,
                                              "inputCustomCreditDay",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "input-group-prepend" },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass: "btn btn-web",
                                              staticStyle: {
                                                border: "1px solid #ced4da"
                                              },
                                              attrs: { type: "button" },
                                              on: {
                                                click: function($event) {
                                                  _vm.form.selectedCredit =
                                                    "cash"
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.creditdasysbutton"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                              _c("i", {
                                                staticClass:
                                                  "far fa-times-circle"
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm.form.selectedCredit !== "cash"
                          ? _c(
                              "div",
                              {
                                staticClass: "col scheduled",
                                class: { disabled: false }
                              },
                              [
                                _c("div", { staticClass: "form-group row" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "col-md-12",
                                      staticStyle: { position: "relative" }
                                    },
                                    [
                                      _c("div", { staticClass: "overlay" }),
                                      _vm._v(" "),
                                      _c("label", [
                                        _vm._v(
                                          _vm._s(_vm.$t("message.scheduled_at"))
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("BaseInputDatePicker", {
                                        attrs: {
                                          availableDates: {
                                            start: _vm.form.created_at,
                                            end: null
                                          }
                                        },
                                        on: {
                                          dayclick: function($event) {
                                            _vm.isFocusOnInputScheduled = true
                                          }
                                        },
                                        model: {
                                          value: _vm.form.scheduled_at,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "scheduled_at",
                                              $$v
                                            )
                                          },
                                          expression: "form.scheduled_at"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("section", [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding" },
                    [
                      _c("section-header", {
                        attrs: { title: _vm.$t("message.orderlist") }
                      }),
                      _vm._v(" "),
                      _c("order", {
                        attrs: {
                          validation: _vm.form.trickValidation,
                          data: _vm.form.orders,
                          createAble: true,
                          showProductImage: true,
                          showTooltipTaxHint: _vm.showTooltipTaxHint,
                          type: "po"
                        },
                        on: { submit: _vm.onSubmitOrder }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("section", { staticClass: "no-margin" }, [
                  _c("div", { staticClass: "col-md-12 no-padding" }, [
                    _c("div", { staticClass: "form-row" }, [
                      _c("div", { staticClass: "col-md-6" }, [
                        _c("div", { staticClass: "form-group row" }, [
                          _c(
                            "div",
                            { staticClass: "col-md-12" },
                            [
                              _c("b-form-textarea", {
                                staticStyle: { "min-height": "126px" },
                                attrs: {
                                  placeholder: _vm.$t("placeholder.note")
                                },
                                model: {
                                  value: _vm.form.note,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "note", $$v)
                                  },
                                  expression: "form.note"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-6 pl-2" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "col-md-12 row no-padding no-margin"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "col-12 row no-margin no-padding"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-6 no-padding mb-2" },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(_vm.$t("message.total")) +
                                          "\n                  "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-6 no-padding mb-2 text-right"
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(_vm.getNumber(_vm.total.sub)) +
                                          "\n                  "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.total.discount > 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 row no-margin no-padding"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "col-6 no-padding mb-2"
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t("message.discount")
                                              ) +
                                              "\n                  "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-6 no-padding mb-2 text-right"
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.getNumber(
                                                  _vm.total.discount
                                                )
                                              ) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.total.discount > 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 row no-margin no-padding"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "col-6 no-padding mb-2"
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "message.discounted_total"
                                                )
                                              ) +
                                              "\n                  "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-6 no-padding mb-2 text-right"
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.getNumber(
                                                  _vm.total.sub -
                                                    _vm.total.discount
                                                )
                                              ) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.total.taxes.vat.inclusive > 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 row no-margin no-padding"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "col-6 no-padding mb-2"
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "message.totalexcludingvat"
                                                )
                                              ) +
                                              "\n                  "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-6 no-padding mb-2 text-right"
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.getNumber(_vm.total.untaxed)
                                              ) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(_vm.taxResults, function(tax, index) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass:
                                      "col-12 row no-margin no-padding"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "col-6 no-padding mb-2" },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(tax.displayText) +
                                            "\n                  "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-6 no-padding mb-2 text-right"
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(_vm.getNumber(tax.total)) +
                                            "\n                  "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-12 row no-margin no-padding"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-6 no-padding" },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(_vm.$t("message.grandtotal")) +
                                          "\n                  "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "col-6 no-padding text-right"
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          class: [
                                            {
                                              "text-underline-border": !_vm.form
                                                .switchWithHoldingTax
                                            }
                                          ]
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.getNumber(_vm.total.grand)
                                              ) +
                                              "\n                    "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.showLegacyWht()
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 row no-margin no-padding"
                                    },
                                    [_vm._m(0)]
                                  )
                                : _vm._e()
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _vm.showLegacyWht()
                            ? [
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-group row mb-0",
                                    staticStyle: { height: "35px" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-8",
                                        staticStyle: {
                                          position: "relative",
                                          top: "3px",
                                          opacity: "0.3"
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.showTooltipTaxHint = true
                                          }
                                        }
                                      },
                                      [
                                        _c("vs-switch", {
                                          staticStyle: {
                                            float: "left",
                                            margin: "0 10px 0 0"
                                          },
                                          attrs: {
                                            disabled: true,
                                            color: "#A3CA76"
                                          },
                                          model: {
                                            value:
                                              _vm.form.switchWithHoldingTax,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "switchWithHoldingTax",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.switchWithHoldingTax"
                                          }
                                        }),
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(_vm.$t("message.wht")) +
                                            "\n                  "
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-4" }, [
                                      _vm.form.switchWithHoldingTax
                                        ? _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.form
                                                      .inputWithHoldingTax,
                                                  expression:
                                                    "form.inputWithHoldingTax"
                                                }
                                              ],
                                              staticClass:
                                                "custom-select form-control",
                                              on: {
                                                change: function($event) {
                                                  var $$selectedVal = Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function(o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function(o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                  _vm.$set(
                                                    _vm.form,
                                                    "inputWithHoldingTax",
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "option",
                                                { attrs: { value: "0" } },
                                                [_vm._v("0%")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "option",
                                                { attrs: { value: "-1" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("message.wht1")
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "option",
                                                { attrs: { value: "-2" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("message.wht2")
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "option",
                                                { attrs: { value: "-3" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("message.wht3")
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "option",
                                                { attrs: { value: "-5" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("message.wht5")
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.form.switchWithHoldingTax
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-md-12 row no-padding mt-2 ml-0 mr-0"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-12 row no-margin no-padding"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-6 no-padding mb-2"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.$t("message.wht")
                                                    ) +
                                                    "\n                    "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-6 no-padding mb-2 text-right"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.getNumber(
                                                        _vm.total.taxes.wht
                                                          .toString()
                                                          .replace("-", "")
                                                      )
                                                    ) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-12 row no-margin no-padding"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-6 no-padding"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.paymentamount"
                                                      )
                                                    ) +
                                                    "\n                    "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-6 no-padding text-right"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "text-underline-border"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getNumber(
                                                          _vm.total.payment
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "section",
                  { staticClass: "action-bar" },
                  [
                    [
                      !_vm.$store.state.app.loading
                        ? _c("div", { staticClass: "col-md-12 text-right" }, [
                            _c("div", { staticClass: "btn-group" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-web",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      _vm.form.trickValidation++
                                      _vm.isCreateAnother = false
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("button.save")))]
                              ),
                              _vm._v(" "),
                              _vm._m(1),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-menu dropdown-menu-right"
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: function($event) {
                                          _vm.form.trickValidation++
                                          _vm.isCreateAnother = true
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("button.saveandcreateanother")
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ])
                        : _c("div", { staticClass: "col-md-12 text-right" }, [
                            _vm._m(2)
                          ])
                    ]
                  ],
                  2
                )
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("BaseConfirmDiscardModal", {
        attrs: { show: _vm.confirmDiscardModal.show },
        on: {
          onCancel: _vm.handleDiscardCancleModal,
          onConfirm: _vm.handleDiscardConfirmModal
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 no-padding" }, [
      _c("hr", { staticStyle: { "border-top": "solid 1px #D8E2E7" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-web dropdown-toggle dropdown-toggle-split",
        attrs: {
          type: "button",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false"
        }
      },
      [_c("span", { staticClass: "sr-only" }, [_vm._v("Toggle Dropdown")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "btn-group" }, [
      _c(
        "button",
        { staticClass: "btn btn-web", attrs: { type: "button", disabled: "" } },
        [_c("i", { staticClass: "fas fa-spinner spin" })]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-web dropdown-toggle dropdown-toggle-split",
          attrs: {
            type: "button",
            "data-toggle": "dropdown",
            "aria-haspopup": "true",
            "aria-expanded": "false",
            disabled: ""
          }
        },
        [_c("span", { staticClass: "sr-only" }, [_vm._v("Toggle Dropdown")])]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "dropdown-menu" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-314653aa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-314653aa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/purchases/po/New.vue
// module id = null
// module chunks = 